// extracted by mini-css-extract-plugin
export default {"main":"g_D","container":"g_F","inner":"g_G","section":"g_Q","videoRresponsive":"g_R","testType":"g_S"};